// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__101uQ","footer":"ModalCreateQualiphyProcedure_footer__1Y-Nr","additionData":"ModalCreateQualiphyProcedure_additionData__F33eb"};